import * as Business   from '../business';
import * as User       from '../user';
import { compose }     from 'redux';
import { connect }     from 'react-redux';
import FetchFromServer from '../components/fetch_from_server';
import Navbar          from '../components/navbar';
import PrimaryButton   from '../components/primary_button';
import React           from 'react';
import restrictAccess  from '../components/restrict_access';


export default connect(
  (state, { businessID }) => ({
    businessID,
    availableRoles: User.getAvailableRoles(),
    currentUserID:  User.getUserID(state),
    statuses:       Business.getTeamStatuses(state, businessID),
    team:           Business.getTeam(state, businessID),
    isAdmin:        User.isAdmin(state, businessID)
  }),
  (dispatch, { businessID }) => ({
    load: compose(dispatch, Business.readTeam, () => businessID)
  })
)(restrictAccess(TeamPage, ({ isAdmin }) => isAdmin));


export function TeamPage({ businessID, currentUserID, availableRoles, team, statuses, load }) {
  return (
    <React.Fragment>
      <Navbar title="Team"/>
      <FetchFromServer statuses={statuses} load={load}>
        {team && (
          <TeamMembers
            businessID={businessID}
            team={team}
            currentUserID={currentUserID}
            availableRoles={availableRoles}
          />
        )}
      </FetchFromServer>
    </React.Fragment>
  );
}


function TeamMembers({ businessID, team, currentUserID, availableRoles }) {
  const me        = team?.users.find(user => user.id === currentUserID);
  const users     = team?.users.filter(user => user.id !== currentUserID);
  const providers = team?.providers;

  return (
    <div className="list media-list block">
      <div className="block">
        <PrimaryButton label="Invite New Team Member" href={`/${businessID}/settings/invite`}/>
      </div>
      <div className="list-group">
        <ul>
          <li className="list-group-title">Members</li>
          {me && <CurrentUser user={me} availableRoles={availableRoles}/>}
          {users?.length > 0 && (
            <Members businessID={businessID} users={users} availableRoles={availableRoles}/>
          )}
        </ul>
      </div>
      {providers?.length > 0 && (
        <Providers businessID={businessID} providers={providers}/>)}
    </div>
  );
}


function CurrentUser({ user, availableRoles }) {
  return (
    <li>
      <div className="item-content">
        <div className="item-inner">
          <div className="item-title-row">
            <div className="item-title">{user.name}</div>
            <div className="item-after">(You)</div>
          </div>
          <div className="item-subtitle">{availableRoles[user.role]}</div>
        </div>
      </div>
    </li>
  );
}


function Members({ businessID, users, availableRoles }) {
  return users
    .sort(alphabetical)
    .map(user => (
      <Member
        key={user.id}
        businessID={businessID}
        user={user}
        availableRoles={availableRoles}/>
    ));
}


function Member({ businessID, user, availableRoles }) {
  return (
    <li>
      <a href={`/${businessID}/settings/team/${user.id}`} className="item-link item-content">
        <div className="item-inner">
          <div className="item-title-row">
            <div className="item-title">{user.name}</div>
          </div>
          <div className="item-subtitle">{availableRoles[user.role]}</div>
        </div>
      </a>
    </li>
  );
}


function Providers({ businessID, providers }) {
  return (
    <div className="list-group">
      <ul>
        <li className="list-group-title">Not yet invited</li>
        {
          providers
            .sort(alphabetical)
            .map(provider => (
              <Provider
                key={provider.id}
                businessID={businessID}
                provider={provider}/>
            ))
        }
      </ul>
    </div>
  );
}


function Provider({ businessID, provider }) {
  return (
    <li key={provider.id}>
      <div className="item-content">
        <div className="item-inner">
          <div className="item-title-row">
            <div className="item-title">{provider.name}</div>
            <div className="item-after">
              <a href={`/${businessID}/settings/invite/${provider.id}`} className="button button-fill">Invite</a>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
}


function alphabetical(a, b) {
  return a.name.localeCompare(b.name);
}
